import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import translations from '../../translations';
import { FaInstagram, FaTiktok, FaFacebookF } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6'; // Newer X icon if React-Icons is v4.10.0+
import './ContactInformation.css';

const ContactInformation = () => {
    const navigate = useNavigate();
    const { language, direction } = useLanguage();
    const t = translations[language];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={`contact-info-page ${direction === 'rtl' ? 'rtl' : ''}`}>
            <div className="contact-info-page__container">
                <button
                    onClick={() => navigate(-1)}
                    className="contact-info-page__back-button"
                    style={{ flexDirection: language === 'ar' ? 'row-reverse' : 'row' }}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>{language === 'ar' ? 'العودة' : 'Back'}</span>
                </button>

                <div className="contact-info-page__header">
                    <h1 className="contact-info-page__title">{language === 'ar' ? 'معلومات التواصل' : 'Contact Information'}</h1>
                    <div className="contact-info-page__divider"></div>
                </div>

                <div className="contact-info-page__content">
                    <div className="contact-info-card">

                        <div className="contact-info-item">
                            <div className="contact-info-icon-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" className="contact-info-icon"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" /></svg>
                            </div>
                            <div className="contact-info-details">
                                <span className="contact-info-label">{language === 'ar' ? 'البريد الإلكتروني' : 'Email'}</span>
                                <a href="mailto:info@aeco.com.sa" className="contact-info-value" dir="ltr">info@aeco.com.sa</a>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-info-icon-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" className="contact-info-icon"><path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" /></svg>
                            </div>
                            <div className="contact-info-details">
                                <span className="contact-info-label">{language === 'ar' ? 'الهاتف' : 'Tel.'}</span>
                                <a href="tel:0112319550" className="contact-info-value" dir="ltr">0112319550</a>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-info-icon-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" className="contact-info-icon"><path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v124q18 7 29 22t11 34v80q0 19-11 34t-29 22v404q0 33-23.5 56.5T680-40H280Zm0-80h400v-720H280v720Zm0 0v-720 720Zm228.5-51.5Q520-183 520-200t-11.5-28.5Q497-240 480-240t-28.5 11.5Q440-217 440-200t11.5 28.5Q463-160 480-160t28.5-11.5Z" /></svg>
                            </div>
                            <div className="contact-info-details">
                                <span className="contact-info-label">{language === 'ar' ? 'الجوال' : 'Mobile'}</span>
                                <a href="tel:0599028000" className="contact-info-value" dir="ltr">0599028000</a>
                            </div>
                        </div>

                        <div className="contact-info-socials">
                            <h3 className="socials-title">{t.socials || (language === 'ar' ? 'وسائل التواصل' : 'Socials')}</h3>
                            <div className="socials-links">
                                <a href="https://x.com/advanced_elmts" target="_blank" rel="noopener noreferrer" className="social-icon-btn x-twitter">
                                    {/* FaXTwitter is not available in older react-icons, fallback to X text if it fails, or use svg */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 1200 1227">
                                        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
                                    </svg>
                                </a>
                                <a href="https://www.instagram.com/advanced_elmts" target="_blank" rel="noopener noreferrer" className="social-icon-btn instagram">
                                    <FaInstagram />
                                </a>
                                <a href="https://www.tiktok.com/@advanced_elmts" target="_blank" rel="noopener noreferrer" className="social-icon-btn tiktok">
                                    <FaTiktok />
                                </a>
                                <a href="https://www.facebook.com/profile.php?id=61565009836404" target="_blank" rel="noopener noreferrer" className="social-icon-btn facebook">
                                    <FaFacebookF />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactInformation;
